/* ===== VENTANA RÁPIDA DE AUTO Y CAMIONETA — ficha técnica completa =====
   theme.js pinta la ventana (#pdModal) y, para moto, le pasa la ficha de moto-ficha.json.
   Para auto no había ficha: la ventana solo mostraba marca, modelo, medida, rin, uso y código.

   Esto NO reescribe theme.js. Observa #pdBody; cuando theme.js termina de pintar una llanta
   de auto (su SKU está en window.AVANTE_AUTO), pide sus metacampos a
   templates/search.ficha-auto.liquid y completa la ventana con:
     · Índice de carga, Índice de velocidad, Tipo, Construcción, Dibujo, Rango de carga, UTQG
     · Descripción (custom.ficha_tecnica)
     · ¿A qué auto le queda? (custom.compatibles), con la nota "(Orientativo por medida…)"
       separada del último chip, igual que en moto.
   Si la petición falla, la ventana se queda como estaba: no se rompe nada.
   Moto no pasa por aquí: su SKU no está en AVANTE_AUTO. */
(function(){
  'use strict';
  var body = document.getElementById('pdBody');
  if(!body || !window.MutationObserver) return;

  var cache = {};

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function cap(s){ s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function esAuto(sku){
    var L = window.AVANTE_AUTO || [];
    for(var i = 0; i < L.length; i++){ if(String(L[i].sk) === sku) return true; }
    return false;
  }

  function pedir(sku){
    if(!cache[sku]){
      cache[sku] = fetch('/search?type=product&view=ficha-auto&q=' + encodeURIComponent(sku), {credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.text() : ''; })
        .then(function(t){
          var i = t.indexOf('{'), j = t.lastIndexOf('}');
          if(i < 0 || j < i) return null;
          try { var d = JSON.parse(t.slice(i, j + 1)); return d && d.found ? d : null; } catch(e){ return null; }
        })
        .catch(function(){ return null; });
    }
    return cache[sku];
  }

  /* La nota final "(Orientativo por medida: …)" viene pegada al último modelo de la lista.
     Se separa para que no quede dentro de un chip. Se parte por comas que NO estén dentro
     de paréntesis ("Mazda 3 (2014, 2015)" es un solo modelo). */
  function compat(raw){
    var limpio = String(raw || '').replace(/\s*\(\s*Orientativo[^)]*\)\.?\s*$/i, '').trim().replace(/[.,;]\s*$/, '');
    return limpio.split(/\n|,\s*(?![^()]*\))/).map(function(s){ return s.trim(); }).filter(Boolean);
  }

  function tituloDe(sec){ var h = sec.querySelector('h4'); return h ? h.textContent.trim() : ''; }

  function aplicar(dl, d){
    if(!document.body.contains(dl) || dl.getAttribute('data-fa-ok')) return;
    dl.setAttribute('data-fa-ok', '1');
    var sec = dl.closest('.pdsec');
    if(!sec) return;

    var filas = [['Índice de carga', d.ic], ['Índice de velocidad', d.iv], ['Tipo', d.tl], ['Construcción', d.cn],
                 ['Dibujo', cap(d.di)], ['Rango de carga', d.rc], ['UTQG', d.ut]];
    var html = filas.filter(function(x){ return x[1]; }).map(function(x){
      return '<div><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd></div>';
    }).join('');
    var codigo = null;
    Array.prototype.forEach.call(dl.children, function(row){
      var dt = row.querySelector('dt');
      if(dt && dt.textContent.trim() === 'Código') codigo = row;
    });
    if(html){
      if(codigo) codigo.insertAdjacentHTML('beforebegin', html);
      else dl.insertAdjacentHTML('beforeend', html);
    }

    var otras = Array.prototype.map.call(sec.parentNode.querySelectorAll('.pdsec'), tituloDe);
    var extra = '';
    if(d.ft && otras.indexOf('Descripción') < 0){
      extra += '<div class="pdsec"><h4>Descripción</h4><p class="pdlede">' + esc(d.ft) + '</p></div>';
    }
    var lista = compat(d.cp);
    if(lista.length){
      /* si la ventana ya trajo una sección de compatibilidad (texto de moto), se reemplaza */
      Array.prototype.forEach.call(sec.parentNode.querySelectorAll('.pdsec'), function(s){
        if(/^¿A qué (moto|auto)/.test(tituloDe(s))) s.parentNode.removeChild(s);
      });
      extra += '<div class="pdsec"><h4>¿A qué auto le queda?</h4>'
        + '<div class="pdchips">' + lista.map(function(m){ return '<span class="pdchip">' + esc(m) + '</span>'; }).join('') + '</div>'
        + '<p class="pdnote">Es orientativo por medida. Antes de instalar confirma la medida y los índices de carga y velocidad que pide tu vehículo — o pregúntanos por WhatsApp.</p></div>';
    }
    if(extra) sec.insertAdjacentHTML('afterend', extra);
  }

  function revisar(){
    var dl = body.querySelector('.pdspecs');
    if(!dl || dl.getAttribute('data-fa')) return;
    dl.setAttribute('data-fa', '1');
    var sku = '';
    Array.prototype.forEach.call(dl.children, function(row){
      var dt = row.querySelector('dt'), dd = row.querySelector('dd');
      if(dt && dd && dt.textContent.trim() === 'Código') sku = dd.textContent.trim();
    });
    if(!sku || !esAuto(sku)) return;
    pedir(sku).then(function(d){ if(d) aplicar(dl, d); });
  }

  new MutationObserver(revisar).observe(body, {childList: true});
  revisar();
})();
